





























import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import Session from '@/app/module/session'

@Component
export default class MapMarker extends Vue {
  private options:any = {
    strokeColor: '',
    strokeOpacity: 0.8,
    strokeWeight: 2,
    fillColor: '',
    fillOpacity: 0.35
  }
  private icon: any = {
    url: require('@/assets/icon/ico_spw.svg'),
    size: { width: 25, height: 25, f: 'px', b: 'px' },
    scaledSize: { width: 25, height: 25, f: 'px', b: 'px' }
  }

  private cameraIcon: any = {
    url: require('@/assets/img/ico_camera.png'),
    size: { width: 25, height: 25, f: 'px', b: 'px' },
    scaledSize: { width: 25, height: 25, f: 'px', b: 'px' }
  }

  /* computed */
  private get fieldChoiceState (): string {
    return this.$store.state.fieldChoiceState.id
  }

  @Watch('fieldChoiceState')
  onIdChange (newValue: string) {
    Session.setChoiceFieldId(newValue)
    if (parseInt(newValue) === this.data.id) {
      this.options.strokeColor = '#ed8f33'
      this.options.fillColor = '#ed8f33'
    } else {
      this.options.strokeColor = this.data.strokeColor
      this.options.fillColor = this.data.fillColor
    }
  }

  @Prop() private data!: any

  created () {
    if (Object.keys(this.data.path).length !== 0) {
      if (this.data.fillColor === '' || this.data.fillColor === 'NULL') {
        this.data.strokeColor = '#FF3535'
        this.data.fillColor = '#FF3535'
      }

      this.options.strokeColor = this.data.strokeColor
      this.options.fillColor = this.data.fillColor
    }
  }

  mounted () {
    if (parseInt(this.$store.state.fieldChoiceState.id) === this.data.id) {
      this.options.strokeColor = '#ed8f33'
      this.options.fillColor = '#ed8f33'
    } else {
      this.options.strokeColor = this.data.strokeColor
      this.options.fillColor = this.data.fillColor
    }
  }

  private click (id: number) {
    this.$store.commit('fieldChoiceState/setChoosingFieldId', String(id))
  }

  private toAgri () {
    window.open('https://agri-note.jp/b/login/mizu.html', '_blank')
  }
}
